import { Box } from "@mui/material";
import {
  AlertCount,
  AlertLabel,
  AlertListPanelHeaderContainer,
} from "./AlertsPanelHeader.style";

type AlertsPanelHeaderProps = {
  alertLabel: string;
  counter?: number;
};

const AlertsPanelHeader = ({ alertLabel, counter }: AlertsPanelHeaderProps) => {
  return (
    <AlertListPanelHeaderContainer>
      <Box sx={{ display: "flex" }}>
        <AlertLabel data-testid="alert-label" variant="subtitle1">
          {alertLabel}
        </AlertLabel>
        &nbsp;
        {counter !== undefined && counter > 0 && (
          <AlertCount data-testid="alert-count" variant="subtitle1">
            ({counter})
          </AlertCount>
        )}
      </Box>
    </AlertListPanelHeaderContainer>
  );
};

export default AlertsPanelHeader;
